import { render, staticRenderFns } from "./ContractSettings.vue?vue&type=template&id=9fa1b5b4&"
import script from "./ContractSettings.vue?vue&type=script&lang=js&"
export * from "./ContractSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports